export const voiceCalls = {
  "head": {
    "title": "Anrufe",
    "subtitle": "Die Anrufe, die Ihre Telefonzentrale entgegengenommen hat."
  },
  "stats": {
    "all": "Anruf | Anrufe",
    "spoken": "beantwortet | beantwortet",
    "inTotal": "insgesamt"
  },
  "toolbar": {
    "searchLabel": "Suche",
    "searchPlaceholder": "Telefonnummer des Anrufers…",
    "clear": "Suche zurücksetzen",
    "showLabel": "Anzeigen",
    "showAll": "Alle Anrufe",
    "showSpoken": "Nur beantwortete",
    "showRecorded": "Nur aufgezeichnete"
  },
  "notice": {
    "noRecording": "Anrufe werden nicht aufgezeichnet.",
    "noRecordingHow": "Aktivieren Sie „Anrufe aufzeichnen“ in den Einstellungen Ihrer Telefonzentrale. Danach können Sie sie hier anhören und transkribieren."
  },
  "empty": {
    "title": "Sie wurden noch nicht angerufen",
    "text": "Wenn jemand Ihre Rezeptionsnummer anruft, erscheint der Anruf hier: wer angerufen hat, wie lange er gedauert hat und worum es ging.",
    "filteredTitle": "Keine Anrufe für diesen Filter",
    "filteredText": "Setzen Sie die Suche oder die Filter oben zurück."
  },
  "item": {
    "notSpoken": "Kein Gespräch",
    "unknownCaller": "Unterdrückte Nummer",
    "linkSent": "Buchungslink gesendet",
    "play": "Aufzeichnung abspielen",
    "pause": "Pause",
    "showTranscript": "Transkript anzeigen",
    "hideTranscript": "Transkript ausblenden",
    "transcribe": "Transkribieren und zusammenfassen",
    "transcribing": "Wird transkribiert…",
    "noRecordingShort": "Dieser Anruf wurde nicht aufgezeichnet",
    "viewReservation": "Buchung ansehen",
    "noSummary": "Für diesen Anruf gibt es keine Zusammenfassung.",
    "copy": "Nummer kopieren",
    "copied": "Kopiert"
  },
  "errors": {
    "load": "Die Anrufe konnten nicht geladen werden.",
    "play": "Die Aufzeichnung konnte nicht abgespielt werden.",
    "transcribe": "Das Transkript konnte nicht angefordert werden."
  },
  "table": {
    "call": "Anruf",
    "reservation": "Buchung",
    "listing": "Unterkunft",
    "summary": "Zusammenfassung",
    "duration": "Dauer",
    "date": "Datum"
  }
};
